<template>
    <dialog-selector
        class="emp-dialog-selector"
        ref="dialogSelector"
        title="选择员工"
        v-on="$listeners"
        v-bind="$attrs"
        :data="groupData"
        :props="{ label: 'name', groupId: 'groupId',}"
		:sidebarProps="{label: 'osname'}"
        search-placeholder="输入员工名称或编号进行搜索"
        :filter-node-method="filterNode"
        :multiple='multiple'
        @click-sidebar-item="onClickSidebarItem"
        @select-change="onSelectChange">
        <template v-slot:node="{ node }">
            <slot name="node" :node="node">
                <div class="emp-selector__item" :title="getTitleText(node)" :class="{'unactive': node.status != 1}">
                    <span class="emp-selector__no">
                        <as-icon v-if="node.status != 1" size="12px" name="biaoji"></as-icon>
                        {{ node.no | cutString(5) }}
                    </span>
                    <span class="emp-selector__name">{{ node.name | cutString(12) }}</span>
                </div>
            </slot>
		</template>
		<template v-slot:sidebarItem="{ menuItem }" >
			<el-badge :value="countMapData[menuItem.id]" :max="99"  v-if='multiple'>
				{{ menuItem.osname | cutString(10) }}
			</el-badge>
		</template>
        <template v-slot:shortcut v-if="shortcutVisible">
            <el-button size="medium" plain @click="handlerSelect(1)">全选</el-button>
            <el-button size="medium" plain @click="handlerSelect(2)">反选</el-button>
        </template>
    </dialog-selector>
</template>
<script>
    import DialogSelector from '@/components/dialog-selector';
    import AsIcon from '@/components/icon'
    import UtilsMixins from '@/mixins/utils'
    export default {
        name: 'EmpDialogSelector',
        components: {
            DialogSelector,
            AsIcon,
        },
        mixins: [UtilsMixins],
        props: {
            groupData: {
                type: Array,
                default: () => []
            },
            multiple: {
                type: Boolean,
                default: true
            },
            shortcutVisible: {
                type: Boolean,
                default: false
            },
        },
        data() {
            return {
                selectShopId: null,
                countMapData: {},
            }
        },
        methods: {
            getTitleText(node) {
                if (!node.no) return node.name;
                return `(${node.no ? node.no : ''})${node.name}`;
            },
            handlerSelect(type) {
                let ids = [];
                this.groupData.forEach(group => {
                    // 全部的id
                    ids.push(...group.children.map(children => children.id));
                });
                if (type !== 1) {
                    // 反选
                    let groupSelectMapData = this.$refs.dialogSelector.groupSelectMapData;
                    let allSelectIds = []; // 已选中的id
                    for (let key in groupSelectMapData) {
                        let mapDataValue = groupSelectMapData[key];
                        let selectIds = mapDataValue.selectIds || [];
                        allSelectIds.push(...selectIds);
                    }
                    ids = ids.filter((id) => !allSelectIds.includes(id)); // 未选中的值
                }
                this.$refs.dialogSelector.setCheckedKeys(ids);
            },
            onSelectChange(groupSelectData) {
                const countMapData = {};
                Object.keys(groupSelectData).forEach(key => {
                    const keyParams = key.split('-');
                    const shopId = Number(keyParams[0]);
                    const length = groupSelectData[key].selectIds.length;
                    if (!countMapData[shopId] && length) {
                        countMapData[shopId] = 0;
                    }
                    if (length) {
                        countMapData[shopId] += length;
                    }
                })
                this.countMapData = countMapData;
            },
            onClickSidebarItem(item) {
                this.selectShopId = item ? item.id : null;
                item && this.$refs.dialogSelector.filter();
            },
            filterNode(value, data) {
                if (!value) {
                    return data.shopId === this.selectShopId;
                }
                const { name, no } = data;
                if ( /^[a-zA-Z]+$/.test(value) && window.pinyin) {   
                    let str = window.pinyin(name, {
                        style: window.pinyin.STYLE_FIRST_LETTER
                    }).join('');
                    str = str.toLowerCase();
                    let valStr = value.toLowerCase();
                    let flag = false;
                    if (str.indexOf(valStr) !== -1) flag = true;
                    return flag;
                } 
                return (name && name.indexOf(value) !== -1) || (no && no.indexOf(value) !== -1);
            },
        }
    }
</script>
<style lang="scss">
.emp-dialog-selector {
    .emp-selector__item {
        width: 100%;
        display: flex;
        color: #333;
        .emp-selector__name{
            display: inline-block;
            padding-left: 5px;
        }
        &.unactive {
            color: #B6B8B9;
        }
    }
}
</style>